import { Tab } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

export type ServerLink = { href: string; to?: string };
export type ClientLink = { href?: string; to: string };

type LinkTabProps = {
  label?: string;
  onClick?: () => void;
  selected?: boolean;
  value: string;
} & (ClientLink | ServerLink);

const LinkTab = (props: LinkTabProps) => (
  <Tab
    component={props.to ? RouterLink : 'a'}
    sx={theme => ({
      color: 'rgba(255 255 255 / 0.7)',
      maxWidth: 'inherit',
      '&.Mui-selected': {
        color: theme.palette.primary.contrastText,
      },
    })}
    {...props}
  />
);

export default LinkTab;
